import { render, staticRenderFns } from "./SelectItem.vue?vue&type=template&id=79e01f7c&scoped=true&"
import script from "./SelectItem.vue?vue&type=script&lang=ts&"
export * from "./SelectItem.vue?vue&type=script&lang=ts&"
import style0 from "./SelectItem.vue?vue&type=style&index=0&id=79e01f7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e01f7c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLabel } from 'vuetify/lib/components/VLabel';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VLabel,VSelect})
